<template>
    <div class="mobileIndex">
        <div class="booking-header">
            <van-sticky>
                <van-nav-bar :title="title" :left-text="showBack?'返回':''" @click-left="goBack">
                    <!-- <template #right>
                        <span class="m-langTxt" @click="show = true">{{langName}}</span>
                        <van-icon name="stop-circle-o" size="18" @click="close"/>
                    </template> -->
                </van-nav-bar>
            </van-sticky>
        </div>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- <van-action-sheet v-model="show" :actions="actions" @select="onSelect" /> -->
    </div>
</template>

<script>
import { NavBar,Icon,ActionSheet,Sticky } from 'vant';
import '@vant/touch-emulator';

export default {
    data() {
        return {
            showBack: false,
            show: false,
            actions: [{name:'中文'},{name:'English'}],
            title: '',
            langName: '',
            viewportHeight: 0
        }
    },

    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [ActionSheet.name]: ActionSheet,
      [Sticky.name]: Sticky 
    },

    computed: {
    },

    created() {
        this.init()
    },
    
    mounted(){
    },

    methods: {
        init(){
            const that = this
            this.scrollIntoView()
            this.title = this.$route.meta.title
            // this.langName = this.language === 'zh' ? '中文' : 'English'

            // 键盘弹起隐藏footer
            // this.viewportHeight = window.innerHeight
            // window.addEventListener('resize',function(){
            //     if(that.viewportHeight - this.innerHeight > 50){ // 键盘弹起
            //         that.changeShowMobileFooter(false)
            //     }else{ // 键盘收起
            //         that.changeShowMobileFooter(true)
            //     }
            // },true)
        },

        scrollIntoView(){
            window.addEventListener('resize', () => {
                const activeElement = document.activeElement
                if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA') {
                    setTimeout(() => {
                        activeElement.scrollIntoView(false)
                    }, 100)
                }
            })
        },

        onSelect(item){
            this.show = false

            const { name } = item
            const lan = name === "中文" ? 'zh' : 'en'

            this.$store.dispatch('setLanguage',lan)
            location.reload()
        },

        goBack(){
            this.$router.go(-1)
        },

        // phoneType () {
        //     let type = navigator.userAgent
        //     if (type.indexOf('Android') > -1 || type.indexOf('Linux') > -1) {
        //         this.$store.dispatch('setPhoneType', 'Android')
        //     } else if (type.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        //         this.$store.dispatch('setPhoneType', 'IOS')
        //     } else {
        //         this.$store.dispatch('setPhoneType', 'Other')
        //     }
        // },
    },
    
    watch: {
        $route: async function(newValue, from) {
            this.$nextTick(() => {
                this.title = newValue.meta.title
                this.showBack = newValue.path !== '/mobile/reserveItems'
            })
        },
    }
}
</script>

<style>
.content-az{
    height: 100% !important;
}
</style>
<style lang="less" scoped>
    .booking-header{
        box-shadow: 0px 0px 5px 0 #f1f1f1;
    }
</style>